import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#5C728A",
      d: "M12 4.929 9.172 7.757l1.414 1.415 2.828-2.829a3.01 3.01 0 0 1 4.243 0 3.01 3.01 0 0 1 0 4.243l-2.828 2.828 1.414 1.414L19.07 12a5 5 0 0 0 0-7.071 5 5 0 0 0-7.071 0m1.414 9.9-2.828 2.828a3.01 3.01 0 0 1-4.243 0 3.01 3.01 0 0 1 0-4.243l2.829-2.828-1.415-1.414L4.93 12a5 5 0 0 0 0 7.071 5 5 0 0 0 7.071 0l2.829-2.828zm-4.95-.708 5.657-5.657 1.415 1.415-5.657 5.657z"
    }, null, -1)
  ]))]))
}
export default { render: render }